import Bold from './bold.js';
let Strike = /*#__PURE__*/(() => {
  class Strike extends Bold {
    static blotName = 'strike';
    static tagName = ['S', 'STRIKE'];
  }
  return Strike;
})();
export default Strike;
